<template>
  <div class="page-component page">
    <slot name="action-bar" />

    <slot />
  </div>
</template>

<style lang="scss" src="./VPage.scss"/>

<script>

import VNotificationsPopup from '@/lib/components/VNotificationsPopup/VNotificationsPopup.vue';
import VLogo               from "@/lib/components/VLogo/VLogo.vue";
import VPopup 						 from "@/lib/components/VPopup/VPopup.vue";

export default {
	name:       'VPage',
	components: {
		VNotificationsPopup,
		VLogo,
		VPopup
	},

	props: {
	},

	data() {
		return {
			debugPopupVisible: false,
		};
	},

	computed: {
		haveActionBarSlot() {
			return this.$slots['action-bar'];
		},
		haveFooterTopSlot() {
			return this.$slots['footer-top'];
		},
		haveFooterMiddleSlot() {
			return this.$slots['footer-middle'];
		},
		haveFooterBottomSlot() {
			return this.$slots['footer-bottom'];
		},
		haveFooter() {
			return this.haveFooterTopSlot || this.haveFooterMiddleSlot || this.haveFooterBottomSlot;
		},
		getFooterClasses() {
			const result = {};
			if (this.haveFooterTopSlot) {
				result['with-top'] = true;
			}
			if (this.haveFooterBottomSlot) {
				result['with-bottom'] = true;
			}
			return result;
		},

    // TODO нужно будет восстановить логику потом
		headerPrependClasses() {
			const result = {
				'page-header-prepend': true,
			};
			const env    = this.$core.config.environment;
			if (env) {
				result[env] = true;
			} else {
				result.development = true;
			}
			return result;
		},
	},

	methods: {
		toggleDebugPopup() {
			this.debugPopupVisible = !this.debugPopupVisible;
		},
	},
};
</script>
